import { render, staticRenderFns } from "./assessment-result.vue?vue&type=template&id=3ef5bfd7&scoped=true&lang=pug&"
import script from "./assessment-result.vue?vue&type=script&lang=ts&"
export * from "./assessment-result.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-result.vue?vue&type=style&index=0&id=3ef5bfd7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef5bfd7",
  null
  
)

export default component.exports